import React from 'react';
import { Button } from '@mui/material';
import { Download as PdfIcon } from '@mui/icons-material';
import { PDFDownloadLink } from '@react-pdf/renderer';
import { ETimsReceiptDocument } from '../pdf/eTimsReceipt';

interface OrderReceiptDownloadProps {
  order: any;
  companyName?: string;
  companyAddress?: string;
  companyPhone?: string;
  companyEmail?: string;
  companyPin?: string;
  etimsSerial?: string;
  label?: string;
  currency?: string;
}

export const OrderReceiptDownload: React.FC<OrderReceiptDownloadProps> = ({
  order,
  companyName = 'Resort',
  companyAddress,
  companyPhone,
  companyEmail,
  companyPin,
  etimsSerial,
  label = 'Download Receipt',
  currency = 'KES',
}) => {
  return (
    <PDFDownloadLink
      document={
        <ETimsReceiptDocument
          order={order}
          companyName={companyName}
          companyAddress={companyAddress}
          companyPhone={companyPhone}
          companyEmail={companyEmail}
          companyPin={companyPin}
          etimsSerial={etimsSerial}
          currency={currency}
        />
      }
      fileName={`fiscal-receipt-${order.order_number}.pdf`}
      style={{ textDecoration: 'none' }}
    >
      {/* @ts-expect-error PDFDownloadLink render-function children */}
      {({ loading }: { loading: boolean }) => (
        <Button
          variant="outlined"
          startIcon={<PdfIcon />}
          disabled={loading}
          sx={{
            border: `1px solid #2C3E2D`,
            borderRadius: 0,
            color: '#2C3E2D',
            px: 2,
            py: 1,
            fontSize: '0.75rem',
            textTransform: 'uppercase',
            letterSpacing: 0.5,
            fontWeight: 600,
            '&:hover': {
              bgcolor: '#2C3E2D',
              color: '#FFF',
              borderColor: '#2C3E2D',
            },
          }}
        >
          {loading ? 'Generating...' : label}
        </Button>
      )}
    </PDFDownloadLink>
  );
};

export default OrderReceiptDownload;
